
	(function () {
		var root = document.getElementById('nn-bioage-template--27862110797918__tool');
		if (!root || root.dataset.nnReady === '1') return;
		root.dataset.nnReady = '1';

		var TYPED_STEPS = 2, TOTAL = 9, CLAMP = { min: -12, max: 15 };

		function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

		function bmiYears(bmi) {
			if (bmi < 18.5) return [1.0, 'Under the healthy range'];
			if (bmi < 25) return [-1.5, 'Healthy range'];
			if (bmi < 30) return [0.5, 'Above the healthy range'];
			if (bmi < 35) return [2.0, 'Well above the healthy range'];
			return [3.5, 'Far above the healthy range'];
		}

		function verdictFor(off) {
			if (off <= -6) return 'Your habits track a long way younger than your years.';
			if (off <= -2) return 'Your habits track younger than your years.';
			if (off < 2) return 'Your habits track close to your actual age.';
			if (off < 6) return 'Your habits track older than your years.';
			return 'Your habits track a long way older than your years.';
		}

		var q = function (s) { return root.querySelector(s); };
		var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
		var steps = qa('[data-step]');
		var state = { step: 0, sex: 'male' };

		function ageValue() { return parseFloat(q('[data-age]').value); }
		function ageOk() { var a = ageValue(); return isFinite(a) && a >= 18 && a <= 90; }

		function heightIn() {
			var f = parseFloat(q('[data-ft]').value);
			var raw = q('[data-in]').value;
			var i = raw.trim() === '' ? 0 : parseFloat(raw);
			return isFinite(f) && isFinite(i) ? f * 12 + i : NaN;
		}

		function bodyOk() {
			var h = heightIn(), w = parseFloat(q('[data-lb]').value);
			return isFinite(h) && h >= 48 && h <= 90 && isFinite(w) && w >= 60 && w <= 500;
		}

		/* Women reach each drinking band sooner, so the labels swap with sex. */
		function applySexToAlcohol() {
			var key = state.sex === 'female' ? 'female' : 'male';
			qa('.nn-choice[data-male]').forEach(function (btn) {
				btn.childNodes[0].nodeValue = btn.getAttribute('data-' + key);
			});
		}

		function show() {
			steps.forEach(function (el) {
				el.hidden = parseInt(el.getAttribute('data-step'), 10) !== state.step;
			});
			var isResult = state.step >= TOTAL;
			q('[data-counter]').hidden = isResult;
			q('[data-restart]').hidden = !isResult;
			q('[data-nav]').hidden = isResult;
			q('[data-counter]').textContent = Math.min(state.step + 1, TOTAL) + ' of ' + TOTAL;
			q('[data-progress]').style.width = (isResult ? 100 : (state.step / TOTAL) * 100) + '%';

			q('[data-back]').disabled = state.step === 0;
			var typed = state.step < TYPED_STEPS;
			q('[data-next]').hidden = !typed;
			q('[data-pick]').hidden = typed;
			if (typed) q('[data-next]').disabled = state.step === 0 ? !ageOk() : !bodyOk();

			q('[data-age-hint]').hidden = q('[data-age]').value.trim() === '' || ageOk();
			q('[data-height-hint]').hidden = q('[data-ft]').value.trim() === '' || bodyOk();
			q('[data-weight-hint]').hidden = q('[data-lb]').value.trim() === '' || bodyOk();
		}

		function contributions() {
			var out = [];
			for (var s = TYPED_STEPS; s < TOTAL; s++) {
				var step = q('[data-step="' + s + '"]');
				var chosen = step.querySelector('.nn-choice[aria-checked="true"]');
				if (chosen) {
					out.push({
						topic: step.getAttribute('data-topic'),
						answer: chosen.textContent.trim(),
						years: parseFloat(chosen.getAttribute('data-years'))
					});
				}
			}
			var h = heightIn(), w = parseFloat(q('[data-lb]').value);
			var bmi = (w * 703) / (h * h);
			var b = bmiYears(bmi);
			out.push({ topic: 'Body weight', answer: b[1], years: b[0] });
			return out;
		}

		function renderResult() {
			var age = ageValue();
			var items = contributions();
			var raw = items.reduce(function (sum, c) { return sum + c.years; }, 0);
			var offset = clamp(raw, CLAMP.min, CLAMP.max);
			var floor = Math.max(18, age - 15);
			var bio = Math.max(floor, age + offset);
			var realOffset = bio - age;

			q('[data-bio]').textContent = String(Math.round(bio));
			q('[data-actual]').textContent = String(Math.round(age));
			var abs = Math.abs(Math.round(realOffset * 10) / 10);
			q('[data-delta]').textContent = realOffset <= -0.05
				? abs + ' years younger'
				: realOffset >= 0.05 ? abs + ' years older' : 'Level with your age';
			q('[data-verdict]').textContent = verdictFor(realOffset);

			var helping = items.filter(function (c) { return c.years < 0; }).sort(function (a, b) { return a.years - b.years; });
			var hurting = items.filter(function (c) { return c.years > 0; }).sort(function (a, b) { return b.years - a.years; });

			function fill(el, list, empty) {
				el.innerHTML = '';
				if (!list.length) {
					var p = document.createElement('li');
					p.className = 'nn-note nn-muted';
					p.textContent = empty;
					el.appendChild(p);
					return;
				}
				list.slice(0, 3).forEach(function (c) {
					var li = document.createElement('li');
					li.style.cssText = 'display:flex;justify-content:space-between;gap:12px;font-size:12px;line-height:1.5';
					var a = document.createElement('span');
					a.textContent = c.topic;
					var b = document.createElement('span');
					b.className = 'nn-display';
					b.textContent = (c.years > 0 ? '+' : '') + c.years.toFixed(1);
					li.appendChild(a);
					li.appendChild(b);
					el.appendChild(li);
				});
			}

			fill(q('[data-helping]'), helping, 'Nothing yet.');
			fill(q('[data-hurting]'), hurting, 'Nothing is adding years.');

			var opp = q('[data-opportunity]');
			if (hurting.length) {
				opp.hidden = false;
				opp.innerHTML = '';
				var strong = document.createElement('span');
				strong.className = 'nn-display';
				strong.textContent = 'Biggest single win: ';
				opp.appendChild(strong);
				opp.appendChild(document.createTextNode(
					hurting[0].topic.toLowerCase() + '. Changing it alone is worth about ' +
					hurting[0].years.toFixed(1) + ' years on this estimate.'
				));
			} else {
				opp.hidden = true;
			}
		}

		qa('[data-sex]').forEach(function (b) {
			b.addEventListener('click', function () {
				state.sex = b.getAttribute('data-sex');
				qa('[data-sex]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
				applySexToAlcohol();
			});
		});

		qa('.nn-choice').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var group = btn.closest('.nn-choices');
				Array.prototype.slice.call(group.querySelectorAll('.nn-choice')).forEach(function (o) {
					o.setAttribute('aria-checked', String(o === btn));
				});
				window.setTimeout(function () {
					state.step = Math.min(state.step + 1, TOTAL);
					if (state.step >= TOTAL) renderResult();
					show();
				}, 180);
			});
		});

		q('[data-next]').addEventListener('click', function () {
			state.step = Math.min(state.step + 1, TOTAL);
			show();
		});

		q('[data-back]').addEventListener('click', function () {
			state.step = Math.max(0, state.step - 1);
			show();
		});

		q('[data-restart]').addEventListener('click', function () {
			state.step = 0;
			qa('.nn-choice').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
			qa('[data-age],[data-ft],[data-in],[data-lb]').forEach(function (el) { el.value = ''; });
			show();
		});

		qa('[data-age],[data-ft],[data-in],[data-lb]').forEach(function (el) {
			el.addEventListener('input', show);
		});

		applySexToAlcohol();
		show();
	})();
